/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';

/**
 * 
 * @export
 * @interface SalesOrderItemAvailabilitySummary
 */
export interface SalesOrderItemAvailabilitySummary {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    id: string;
    /**
     * 
     * @type {SalesOrderItemAvailabilitySummaryStatusEnum}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    status: SalesOrderItemAvailabilitySummaryStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    quantity: number;
    /**
     * 
     * @type {Date}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    lastGoodsReceiptAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    itemId: string;
    /**
     * 
     * @type {Date}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderItemAvailability?: Date;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderItemPricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderItemDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderItemDiscountedPricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderItemTotal: number;
    /**
     * 
     * @type {Date}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    salesOrderCreatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productThumbnailUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productManufacturers: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productTypes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    productThemes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    gtin?: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    customerOrderNumber?: HeoTransactionNumber;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    customerItemReference?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    customerReference?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    infoToCustomer?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderItemAvailabilitySummary
     */
    currencyIsoCode?: string;
}


/**
 * @export
 */
export const SalesOrderItemAvailabilitySummaryStatusEnum = {
    InStock: 'IN_STOCK',
    InStockOverdue: 'IN_STOCK_OVERDUE',
    InStockNotReleased: 'IN_STOCK_NOT_RELEASED',
    Incoming: 'INCOMING',
    InPreorder: 'IN_PREORDER',
    OnRequest: 'ON_REQUEST'
} as const;
export type SalesOrderItemAvailabilitySummaryStatusEnum = typeof SalesOrderItemAvailabilitySummaryStatusEnum[keyof typeof SalesOrderItemAvailabilitySummaryStatusEnum];


/**
 * Check if a given object implements the SalesOrderItemAvailabilitySummary interface.
 */
export function instanceOfSalesOrderItemAvailabilitySummary(value: object): value is SalesOrderItemAvailabilitySummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('salesOrderItemPricePerUnit' in value) || value['salesOrderItemPricePerUnit'] === undefined) return false;
    if (!('salesOrderItemDiscount' in value) || value['salesOrderItemDiscount'] === undefined) return false;
    if (!('salesOrderItemDiscountedPricePerUnit' in value) || value['salesOrderItemDiscountedPricePerUnit'] === undefined) return false;
    if (!('salesOrderItemTotal' in value) || value['salesOrderItemTotal'] === undefined) return false;
    if (!('salesOrderCreatedAt' in value) || value['salesOrderCreatedAt'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productManufacturers' in value) || value['productManufacturers'] === undefined) return false;
    if (!('productTypes' in value) || value['productTypes'] === undefined) return false;
    if (!('productThemes' in value) || value['productThemes'] === undefined) return false;
    return true;
}

export function SalesOrderItemAvailabilitySummaryFromJSON(json: any): SalesOrderItemAvailabilitySummary {
    return SalesOrderItemAvailabilitySummaryFromJSONTyped(json, false);
}

export function SalesOrderItemAvailabilitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemAvailabilitySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'quantity': json['quantity'],
        'lastGoodsReceiptAt': json['lastGoodsReceiptAt'] == null ? undefined : (new Date(json['lastGoodsReceiptAt'])),
        'itemId': json['itemId'],
        'salesOrderItemAvailability': json['salesOrderItemAvailability'] == null ? undefined : (new Date(json['salesOrderItemAvailability'])),
        'salesOrderItemPricePerUnit': json['salesOrderItemPricePerUnit'],
        'salesOrderItemDiscount': json['salesOrderItemDiscount'],
        'salesOrderItemDiscountedPricePerUnit': json['salesOrderItemDiscountedPricePerUnit'],
        'salesOrderItemTotal': json['salesOrderItemTotal'],
        'salesOrderCreatedAt': (new Date(json['salesOrderCreatedAt'])),
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productThumbnailUrl': json['productThumbnailUrl'] == null ? undefined : json['productThumbnailUrl'],
        'productManufacturers': json['productManufacturers'],
        'productTypes': json['productTypes'],
        'productThemes': json['productThemes'],
        'gtin': json['gtin'] == null ? undefined : json['gtin'],
        'customerOrderNumber': json['customerOrderNumber'] == null ? undefined : HeoTransactionNumberFromJSON(json['customerOrderNumber']),
        'customerItemReference': json['customerItemReference'] == null ? undefined : json['customerItemReference'],
        'customerReference': json['customerReference'] == null ? undefined : json['customerReference'],
        'infoToCustomer': json['infoToCustomer'] == null ? undefined : json['infoToCustomer'],
        'currencyIsoCode': json['currencyIsoCode'] == null ? undefined : json['currencyIsoCode'],
    };
}

export function SalesOrderItemAvailabilitySummaryToJSON(json: any): SalesOrderItemAvailabilitySummary {
    return SalesOrderItemAvailabilitySummaryToJSONTyped(json, false);
}

export function SalesOrderItemAvailabilitySummaryToJSONTyped(value?: SalesOrderItemAvailabilitySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'quantity': value['quantity'],
        'lastGoodsReceiptAt': value['lastGoodsReceiptAt'] == null ? value['lastGoodsReceiptAt'] : value['lastGoodsReceiptAt'].toISOString(),
        'itemId': value['itemId'],
        'salesOrderItemAvailability': value['salesOrderItemAvailability'] == null ? value['salesOrderItemAvailability'] : value['salesOrderItemAvailability'].toISOString(),
        'salesOrderItemPricePerUnit': value['salesOrderItemPricePerUnit'],
        'salesOrderItemDiscount': value['salesOrderItemDiscount'],
        'salesOrderItemDiscountedPricePerUnit': value['salesOrderItemDiscountedPricePerUnit'],
        'salesOrderItemTotal': value['salesOrderItemTotal'],
        'salesOrderCreatedAt': value['salesOrderCreatedAt'].toISOString(),
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productThumbnailUrl': value['productThumbnailUrl'],
        'productManufacturers': value['productManufacturers'],
        'productTypes': value['productTypes'],
        'productThemes': value['productThemes'],
        'gtin': value['gtin'],
        'customerOrderNumber': HeoTransactionNumberToJSON(value['customerOrderNumber']),
        'customerItemReference': value['customerItemReference'],
        'customerReference': value['customerReference'],
        'infoToCustomer': value['infoToCustomer'],
        'currencyIsoCode': value['currencyIsoCode'],
    };
}

